import { MailOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, message } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { FloatingLabelField } from "../../components/FloatingLabelField";
import { resetPassword } from "../../apis/loginApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
  const [form] = Form.useForm();
  const query = useQuery();
  const token = query.get("token");
  const history = useHistory();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const onFinish = async ({ password }) => {
    if (!token) {
      message.error(t("The reset token is invalid or has expired"));
      return;
    }
    setLoading(true);
    try {
      await resetPassword(password, token);
      history.push("/login");
      message.success(t("Your password has been reset successfully"));
    } catch {
      message.error(t("The reset token is invalid or has expired"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 !px-5">
      <div className="bg-white !p-6 lg:!p-8 shadow rounded-xl w-11/12 lg:w-2/5">
        <div className="w-full flex flex-col items-center gap-2 mb-2">
          <img src="/assets/img/brand/logo.png" width={180} alt="" />
          <div className="rounded-xl text-center">
            <Divider className="!px-14 mt-0 !mb-4 !border-main">
              <MailOutlined className="text-2xl text-main" />
            </Divider>
            <span>{t("Please enter a new password for your account")}</span>
          </div>
        </div>
        <Form layout="vertical" form={form} onFinish={onFinish} size="large">
          <Form.Item name="password" className="!mb-2" rules={[{ required: true }, { min: 6 }]}>
            <FloatingLabelField label={t("New password")}>
              <Input.Password />
            </FloatingLabelField>
          </Form.Item>
          <Form.Item
            name="confirm"
            dependencies={["password"]}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("Passwords do not match")));
                },
              }),
            ]}
          >
            <FloatingLabelField label={t("Confirm password")}>
              <Input.Password />
            </FloatingLabelField>
          </Form.Item>
          <Form.Item className="!mt-10 mb-2">
            <Button
              type="primary"
              htmlType="submit"
              className="flex-center !bg-main"
              block
              icon={<SaveOutlined />}
              loading={loading}
            >
              {t("Change password")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
